// ** Core Imports
import { React, useEffect, useState } from "react"
import AsyncSelect from "react-select/async"
import { Controller, useForm } from "react-hook-form"
import { useSelector } from "react-redux"

// ** Icons
//import { CreditCard, Truck } from "react-feather"
// ** Third Party Components
import { Col, Form, Button, Label, Row, Input, FormFeedback, Spinner } from "reactstrap"
import Swal from "sweetalert2"
import Flatpickr from "react-flatpickr"
import withReactContent from "sweetalert2-react-content"
// ** Utils
import { getISODateUTC } from "@lib/util"
import {
  addEventInPersonHistory,
  getPersonInteractions,
  getLoggedInUser,
  getProductModel,
  getProductSize,
  sendEmailComplaint,
  getShowrooms
} from "@lib/api"
//import { UNKNOWN_PARTNER } from "@lib/constants"
const ComplaintForm = (props) => {
  const store = useSelector((state) => state.persons)
  const MySwal = withReactContent(Swal)
  const today = getISODateUTC().split("Z")[0]
  const [user, setUser] = useState({})
  const [product, setProduct] = useState(1)
  const [productModel, setProductModel] = useState()
  const [productModelId, setProductModelId] = useState()
  const [typeProduct, setTypeProduct] = useState()
  const [productSize, setProductSize] = useState([])
  const [disabledModel, setDisabledModel] = useState(true)
  const [disabledSize, setDisabledSize] = useState(true)
  const [disactivateButton, setDisactivateButton] = useState(true)
  const [showroomList, setShowroomList] = useState([])

  const firmness = [
    { value: "Soft", label: "Soft" },
    { value: "Medium-Firm", label: "Medium-Firm" },
    { value: "Firm", label: "Firm" }
  ]

  const selectAddress = []
  const selectEmail = []
  const selectTel = []

  for (let i = 0; i < store.selectedPerson.addresses.length; i++) {
    selectAddress.push({
      value: store.selectedPerson.addresses[i].id,
      label: store.selectedPerson.addresses[i].street
    })
  }

  for (let i = 0; i < store.selectedPerson.emails.length; i++) {
    selectEmail.push({
      value: store.selectedPerson.emails[i].id,
      label: store.selectedPerson.emails[i].address
    })
  }

  for (let i = 0; i < store.selectedPerson.phones.length; i++) {
    selectTel.push({
      value: store.selectedPerson.phones[i].id,
      label: store.selectedPerson.phones[i].number
    })
  }

  // constants

  let defaultValues = {}
  if (store.selectedPerson) {
    // if it's the default DB date, fallback to minDate to avoid error
    let defaultDate = store.selectedPerson.birthDate
    if (defaultDate === "0001-01-01T00:00:00") {
      defaultDate = MIN_BIRTHDATE
    }
    defaultValues = {
      date: today,
      weight: "",
      height: "",
      currencyId: 0,
      currencyLabel: "",
      addresses: store.selectedPerson.addresses,
      deliveryAddressId: store.selectedPerson.addresses[0].id,
      billingAddressId: store.selectedPerson.addresses[0].id,
      id: store.selectedPerson.id,
      isVIP: store.selectedPerson.isVIP,
      title: { label: store.selectedPerson.title.name, value: store.selectedPerson.title.id },
      gender: { label: store.selectedPerson.gender.name, value: store.selectedPerson.gender.id },
      firstName: store.selectedPerson.firstName,
      name: store.selectedPerson.name,
      language: {
        label: store.selectedPerson.language.name,
        value: store.selectedPerson.language.id
      },
      annualIncome: store.selectedPerson.annualIncome,
      isBirthDateExact: store.selectedPerson.isBirthDateExact,
      birthDate: store.selectedPerson.isBirthDateExact === true ? defaultDate : "",
      estimatedBirthDate: store.selectedPerson.isBirthDateExact === false ? defaultDate : ""
    }
  } else {
    defaultValues = {
      date: today,
      weight: "",
      height: "",
      currencyId: 0,
      currencyLabel: "",
      addresses: store.selectedPerson.addresses,
      deliveryAddressId: store.selectedPerson.addresses[0].id,
      billingAddressId: store.selectedPerson.addresses[0].id,
      isVIP: false,
      isBirthDateExact: false,
      name: "",
      firstName: "",
      annualIncome: ""
    }
  }

  // Hooks and States
  const {
    control,
    setValue,
    handleSubmit,
    getValues,
    watch,
    formState: { errors, isSubmitting, isSubmitSuccessful }
  } = useForm({ defaultValues })

  useEffect(() => {
    getLoggedInUser().then((user) => setUser(user))
  }, [])

  useEffect(() => {
    const fetchShowroom = async () => {
      try {
        const showroom = await getShowrooms()
        const data = showroom.data
        const options = data.map((item) => {
          return {
            value: item.id,
            label: item.name
          }
        })
        setShowroomList(options)
      } catch (error) {
        console.error("Error fetching product model:", error)
      }
    }

    fetchShowroom()
  }, [])

  const getValueOrDefault = (value, defaultValue = "") => value || defaultValue

  const sendAllTheInfo = async () => {
    let productDetails = {}
    let attachments = []
    let nameProduct = ""
    let theEventReasonId = 0
    const selectedFilesMattress = getValues("mattressPictures")
    const selectedFilesBoxspring = getValues("boxspringPictures")
    const selectedFilesHeadboard = getValues("headboardPictures")
    const selectedFilesDuvet = getValues("duvetPictures")

    const productDetailsMattress = {
      ProductType: typeProduct,
      Model: getValueOrDefault(getValues("mattressModel")?.label),
      Size: getValueOrDefault(getValues("mattressSize")?.label),
      Firmness: getValueOrDefault(getValues("mattressFirmness")?.label),
      Quantity: getValueOrDefault(getValues("mattressQuantity")),
      SleepingPosition: getValueOrDefault(getValues("mattressSleepingPosition")?.label),
      ReasonForComplaint: getValueOrDefault(getValues("mattressComplaintReason")?.label),
      OtherDetails: getValueOrDefault(getValues("mattressOther")),
      Description: getValueOrDefault(getValues("mattressProblemDetail"))
    }

    const productDetailsBoxspring = {
      Model: productModel,
      Size: getValueOrDefault(getValues("boxspringSize")?.label),
      ReasonForComplaint: getValueOrDefault(getValues("boxspringComplaintReason")?.label),
      Description: getValueOrDefault(getValues("boxspringProblemDetail"))
    }

    const productDetailsHeadboard = {
      Model: productModel,
      Size: getValueOrDefault(getValues("headboardSize")?.label),
      ReasonForComplaint: getValueOrDefault(getValues("headboardComplaintReason")?.label),
      Description: getValueOrDefault(getValues("headboardProblemDetail"))
    }

    const productDetailsDuvet = {
      ProductType: typeProduct,
      Model: getValueOrDefault(getValues("duvetModel")?.label),
      Size: getValueOrDefault(getValues("duvetSize")?.label),
      ReasonForComplaint: getValueOrDefault(getValues("duvetComplaintReason")?.label),
      Description: getValueOrDefault(getValues("duvetProblemDetail"))
    }

    if (product === 1) {
      productDetails = productDetailsMattress
      attachments = selectedFilesMattress ? Array.from(selectedFilesMattress) : []
      nameProduct = "Mattress"
      theEventReasonId = 71
    } else if (product === 2) {
      productDetails = productDetailsBoxspring
      attachments = selectedFilesBoxspring ? Array.from(selectedFilesBoxspring) : []
      nameProduct = "Boxspring"
      theEventReasonId = 72
    } else if (product === 3) {
      productDetails = productDetailsHeadboard
      attachments = selectedFilesHeadboard ? Array.from(selectedFilesHeadboard) : []
      nameProduct = "Headboard"
      theEventReasonId = 73
    } else if (product === 4) {
      productDetails = productDetailsDuvet
      attachments = selectedFilesDuvet ? Array.from(selectedFilesDuvet) : []
      nameProduct = "Duvet"
      theEventReasonId = 74
    }

    const payload = {
      OrderNumber: getValueOrDefault(getValues("orderNumber")),
      Showroom: getValueOrDefault(getValues("showroomId")?.label),
      DeliveryDate: getValues("deliveryDate")?.[0]?.toISOString() || "", // Check if the value exists before calling `toISOString()`
      FirstName: getValueOrDefault(getValues("firstName")),
      LastName: getValueOrDefault(getValues("name")),
      Address: getValueOrDefault(getValues("address")?.label),
      Email: getValueOrDefault(getValues("email")?.label),
      PhoneNumber: getValueOrDefault(getValues("tel")?.label),
      ProductType: nameProduct,
      ProductDetails: productDetails,
      Link: window.location.href,
      Attachments: attachments
    }
    try {
      const response = await sendEmailComplaint(payload)
      if (response.status === 200) {
        const interactions = await getPersonInteractions(
          store.selectedPerson.id,
          user.internalCompanyId
        )
        const firstInteractionId = interactions[0].id

        const cleanData = {
          interactionId: firstInteractionId,
          collaboratorId: user.collaboratorId,
          showroomId: getValues("showroomId")?.value,
          description: productDetails.ProblemDetail,
          eventReasonId: theEventReasonId,
          // weird formatting with flatpickr
          on: getISODateUTC(new Date())
        }
        await addEventInPersonHistory(cleanData)
        MySwal.fire({
          title: "Success",
          text: "Email sent successfully",
          icon: "success"
        })
      }
    } catch (error) {
      console.error("Error sending email:", error)
      MySwal.fire({
        title: "Error",
        text: "Need to fill in all the fields",
        icon: "error"
      })
    }
  }

  // Submit form functions
  const onSubmit = async () => {
    await sendAllTheInfo()
  }

  const watchedFields = watch([
    "orderNumber",
    "deliveryDate",
    "firstName",
    "name",
    "address",
    "showroomId",
    "mattressModel",
    "mattressSize",
    "mattressFirmness",
    "mattressQuantity",
    "mattressSleepingPosition",
    "mattressComplaintReason",
    "mattressProblemDetail",
    "boxspringModel",
    "boxspringSize",
    "boxspringComplaintReason",
    "boxspringProblemDetail",
    "headboardModel",
    "headboardSize",
    "headboardComplaintReason",
    "headboardProblemDetail",
    "duvetModel",
    "duvetSize",
    "duvetComplaintReason",
    "duvetProblemDetail"
  ])

  useEffect(() => {
    const fetchModel = async () => {
      try {
        if (!typeProduct) return
        const model = await getProductModel(typeProduct)

        // Dynamically find the ID property
        const options = model.map((item) => {
          const idKey = Object.keys(item).find((key) => key.toLowerCase().includes("id"))
          return {
            value: item[idKey],
            label: item.name
          }
        })

        setProductModel(options)
      } catch (error) {
        console.error("Error fetching product model:", error)
      }
    }

    fetchModel()
  }, [typeProduct])

  useEffect(() => {
    const fetchModel = async () => {
      if (!productModelId || !typeProduct) return
      const productSize = await getProductSize(typeProduct, productModelId)
      if (productSize === undefined) {
        return // Exit if productSize is undefined
      }
      if (!productSize && !productSize.result && !productSize.options) {
        return // Exit if productSize or its result property is undefined
      }
      const productModelSize = []
      const height = productSize.result?.Height || productSize.options?.Height || []
      const width = productSize.result?.Width || productSize.options?.Width || []
      const length = productSize.result?.Length || productSize.options?.Length || []

      const heights = height.length > 0 ? height : [null]
      const widths = width.length > 0 ? width : [null]
      const lengths = length.length > 0 ? length : [null]

      for (let i = 0; i < heights.length; i++) {
        for (let j = 0; j < widths.length; j++) {
          for (let k = 0; k < lengths.length; k++) {
            // Create parts only if they are not null
            const sizeParts = [
              heights[i] !== null ? `H${heights[i]}` : "",
              widths[j] !== null ? `W${widths[j]}` : "",
              lengths[k] !== null ? `L${lengths[k]}` : ""
            ]

            // Join the non-empty parts with 'x'
            const sizeString = sizeParts.filter((part) => part).join("x")

            productModelSize.push({
              value: sizeString,
              label: sizeString
            })
          }
        }
      }
      setProductSize(productModelSize)
    }

    fetchModel()
  }, [productModelId])

  useEffect(() => {
    const productDetailsMattress = {
      ProductType: typeProduct,
      Model: getValues("mattressModel"),
      Size: getValues("mattressSize"),
      Firmness: getValues("mattressFirmness"),
      Quantity: getValues("mattressQuantity"),
      SleepingPosition: getValues("mattressSleepingPosition"),
      ReasonForComplaint: getValues("mattressComplaintReason"),
      ProblemDetail: getValues("mattressProblemDetail")
    }
    const productDetailsBoxspring = {
      Model: productModelId,
      Size: getValues("boxspringSize"),
      ReasonForComplaint: getValues("boxspringComplaintReason"),
      ProblemDetail: getValues("boxspringProblemDetail")
    }
    const productDetailsHeadboard = {
      Model: productModelId,
      Size: getValues("headboardSize"),
      ReasonForComplaint: getValues("headboardComplaintReason"),
      ProblemDetail: getValues("headboardProblemDetail")
    }

    const productDetailsDuvet = {
      ProductType: typeProduct,
      Model: getValues("duvetModel"),
      Size: getValues("duvetSize"),
      ReasonForComplaint: getValues("duvetComplaintReason"),
      ProblemDetail: getValues("duvetProblemDetail")
    }
    let productDetails = {}
    if (product === 1) {
      productDetails = productDetailsMattress
    } else if (product === 2) {
      productDetails = productDetailsBoxspring
    } else if (product === 3) {
      productDetails = productDetailsHeadboard
    } else if (product === 4) {
      productDetails = productDetailsDuvet
    }

    const payload = {
      OrderNumber: getValues("orderNumber"),
      DeliveryDate: getValues("deliveryDate"),
      FirstName: getValues("firstName"),
      LastName: getValues("name"),
      Address: getValues("address"),
      showroomId: getValues("showroomId"),
      allProductDetails: productDetails
    }

    const allTopLevelFieldsFilled = Object.values(payload).every(
      (value) => value !== undefined && value !== null && value !== ""
    )

    // Check if all the fields within productDetails are not undefined, null, or empty
    const allProductDetailsFilled = Object.values(productDetails).every(
      (value) => value !== undefined && value !== null && value !== ""
    )

    if (allTopLevelFieldsFilled && allProductDetailsFilled) {
      setDisactivateButton(false)
    } else {
      setDisactivateButton(true)
    }
  }, [watchedFields])

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className="text-center mb-2">
        <h1 className="mb-1">Add New {props.eventReason.label}</h1>
        <p>Create a new {props.eventReason.label} in the Configurator.</p>
      </div>
      <h5>INFORMATION</h5>
      <Row className="mb-1">
        <Col md="6" className="mb-1">
          <Label for="orderNumber">Order number</Label>
          <Controller
            id="orderNumber"
            name="orderNumber"
            control={control}
            render={({ field }) => (
              <Input placeholder="ID" invalid={errors.orderNumber && true} {...field} />
            )}
          />
          {errors.orderNumber && <FormFeedback>{errors.orderNumber.message}</FormFeedback>}
        </Col>
        <Col md="6" className="mb-1">
          <Label for="showroomId">Showroom</Label>
          {showroomList && (
            <Controller
              name="showroomId"
              id="showroomId"
              control={control}
              render={({ field }) => (
                <AsyncSelect
                  {...field}
                  isClearable
                  isSearchable
                  className="react-select"
                  classNamePrefix="select"
                  cacheOptions
                  defaultOptions={showroomList}
                />
              )}
            />
          )}
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md="6" className="mb-1">
          <Label for="deliveryDate">Delivery date</Label>
          <Controller
            name="deliveryDate"
            id="deliveryDate"
            control={control}
            render={({ field }) => (
              <Flatpickr
                {...field}
                className="form-control"
                options={{
                  dateFormat: "Y-m-d"
                }}
              />
            )}
          />
        </Col>
        <Col md="6" className="mb-1">
          <Label for="firstName">First Name</Label>
          <Controller
            id="firstName"
            name="firstName"
            control={control}
            render={({ field }) => (
              <Input placeholder="First Name" invalid={errors.firstName && true} {...field} />
            )}
          />
          {errors.firstName && <FormFeedback>{errors.firstName.message}</FormFeedback>}
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md="6" className="mb-1">
          <Label for="name">Last Name</Label>
          <Controller
            id="name"
            name="name"
            control={control}
            render={({ field }) => (
              <Input placeholder="Doe" invalid={errors.name && true} {...field} />
            )}
          />
          {errors.name && <FormFeedback>{errors.name.message}</FormFeedback>}
        </Col>
        <Col md="6" className="mb-1">
          <Label for="address">Address</Label>
          <Controller
            name="address"
            id="address"
            control={control}
            defaultValue={selectAddress.length >= 1 ? selectAddress[0] : null} // Set default value here
            render={({ field }) => (
              <AsyncSelect
                {...field}
                isClearable
                isSearchable
                className="react-select"
                classNamePrefix="select"
                cacheOptions
                defaultOptions={selectAddress}
              />
            )}
          />
          {errors.address && <FormFeedback>{errors.address.message}</FormFeedback>}
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md="6" className="mb-1">
          <Label for="address">E-mail</Label>
          <Controller
            name="email"
            id="email"
            control={control}
            defaultValue={selectEmail.length >= 1 ? selectEmail[0] : null} // Set default value here
            render={({ field }) => (
              <AsyncSelect
                {...field}
                isClearable
                isSearchable
                className="react-select"
                classNamePrefix="select"
                cacheOptions
                defaultOptions={selectEmail}
              />
            )}
          />
          {errors.address && <FormFeedback>{errors.address.message}</FormFeedback>}
        </Col>
        <Col md="6" className="mb-1">
          <Label for="tel">Numéro de téléphone</Label>
          <Controller
            name="tel"
            id="tel"
            control={control}
            defaultValue={selectTel.length >= 1 ? selectTel[0] : null} // Set default value here
            render={({ field }) => (
              <AsyncSelect
                {...field}
                isClearable
                isSearchable
                className="react-select"
                classNamePrefix="select"
                cacheOptions
                defaultOptions={selectTel}
              />
            )}
          />
          {errors.address && <FormFeedback>{errors.address.message}</FormFeedback>}
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md="6" className="mb-1">
          <Label for="complaintArticle">Complaint article</Label>
          <Controller
            name="complaintArticle"
            id="complaintArticle"
            control={control}
            render={({ field }) => (
              <AsyncSelect
                {...field}
                isClearable
                isSearchable
                className="react-select"
                classNamePrefix="select"
                cacheOptions
                onChange={(e) => {
                  if (e && e.value) setProduct(e.value)
                  else setProduct(1)
                  if (e && e.value && e.value === 1) {
                    setDisabledModel(true)
                    setTypeProduct(null)
                  }
                  if (e && e.value && e.value === 4) {
                    setDisabledModel(true)
                    setTypeProduct(null)
                  }
                  if (e && e.value && e.value === 2) setTypeProduct("MattressBase")
                  if (e && e.value && e.value === 3) setTypeProduct("Headboard")
                  setValue("mattressModel", null)
                  setValue("duvetModel", null)
                  setValue("mattressSize", null)
                  setValue("headboardSize", null)
                  setValue("boxspringSize", null)
                  setValue("duvetSize", null)
                  setDisabledSize(true)
                }}
                defaultOptions={[
                  { value: 1, label: "Mattress" },
                  { value: 2, label: "Boxspring / Frame / Ambiance E-Motion" },
                  { value: 3, label: "Headboard" },
                  { value: 4, label: "Duvet / Pillow / Bed linen / Accessories" }
                ]}
                defaultInputValue="Mattress"
              />
            )}
          />
          {errors.address && <FormFeedback>{errors.address.message}</FormFeedback>}
        </Col>
      </Row>
      {product === 1 && (
        <>
          <hr className="my-3" />
          <h5>Mattress</h5>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="mattressProduct">Product type</Label>
              <Controller
                name="mattressProduct"
                id="mattressProduct"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    onChange={(e) => {
                      if (e && e.value) setTypeProduct(e.value)
                      setValue("mattressModel", null)
                      setValue("mattressSize", null)
                      setDisabledSize(true)
                      setDisabledModel(false)
                    }}
                    defaultOptions={[
                      { value: "Mattress", label: "Mattress" },
                      { value: "MattressTopper", label: "Mattress topper" },
                      { value: "FullBed", label: "Full bed" }
                    ]}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="6" className="mb-1">
              <Label for="mattressModel">Model</Label>
              <Controller
                name="mattressModel"
                id="mattressModel"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    isDisabled={disabledModel}
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={productModel}
                    loadOptions={() => Promise.resolve(productModel)}
                    onChange={(e) => {
                      field.onChange(e) // Ensure the field value is updated
                      setDisabledSize(false)
                      setValue("mattressSize", null)
                      setProductModelId(e ? e.value : null)
                    }}
                  />
                )}
              />
            </Col>
            <Col md="6" className="mb-1">
              <Label for="mattressSize">Size</Label>
              <Controller
                name="mattressSize"
                id="mattressSize"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    isDisabled={disabledSize}
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={productSize}
                    loadOptions={() => Promise.resolve(productSize)}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="6" className="mb-1">
              <Label for="mattressFirmness">Firmness</Label>
              <Controller
                name="mattressFirmness"
                id="mattressFirmness"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={firmness}
                  />
                )}
              />
            </Col>
            <Col md="6" className="mb-1">
              <Label for="mattressQuantity">Quantity</Label>
              <Controller
                id="mattressQuantity"
                name="mattressQuantity"
                control={control}
                render={({ field }) => (
                  <Input
                    placeholder="Quantity"
                    type="number"
                    invalid={errors.mattressQuantity && true}
                    {...field}
                  />
                )}
              />
              {errors.mattressQuantity && (
                <FormFeedback>{errors.mattressQuantity.message}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="6" className="mb-1">
              <Label for="mattressSleepingPosition">Sleeping position</Label>
              <Controller
                name="mattressSleepingPosition"
                id="mattressSleepingPosition"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={[
                      { value: "stomach", label: "Stomach" },
                      { value: "side", label: "Side" },
                      { value: "back", label: "Back" }
                    ]}
                  />
                )}
              />
            </Col>
            <Col md="6" className="mb-1">
              <Label for="mattressComplaintReason">Reason for complaint</Label>
              <Controller
                name="mattressComplaintReason"
                id="mattressComplaintReason"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={[
                      { value: "sleep_dream", label: "Sleep & Dream" },
                      { value: "manufacturing_defect", label: "Manufacturing defect" },
                      { value: "pain", label: "Pain (neck, shoulder, lower back, hip/pelvis)" }
                    ]}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="mattressOther">Other</Label>
              <Controller
                id="mattressOther"
                name="mattressOther"
                control={control}
                render={({ field }) => (
                  <Input placeholder="Other" invalid={errors.mattressOther && true} {...field} />
                )}
              />
              {errors.mattressOther && <FormFeedback>{errors.mattressOther.message}</FormFeedback>}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="mattressProblemDetail">Please describe the problem in more detail:</Label>
              <Controller
                id="mattressProblemDetail"
                name="mattressProblemDetail"
                control={control}
                render={({ field }) => (
                  <Input
                    type="textarea"
                    placeholder="Describe the problem"
                    invalid={errors.mattressProblemDetail && true}
                    {...field}
                  />
                )}
              />
              {errors.mattressProblemDetail && (
                <FormFeedback>{errors.mattressProblemDetail.message}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="mattressPictures">Pictures</Label>
              <Controller
                id="mattressPictures"
                name="mattressPictures"
                control={control}
                render={({ field }) => (
                  <Input
                    type="file"
                    placeholder="Upload pictures"
                    invalid={errors.pictures && true}
                    multiple
                    onChange={(e) => {
                      // Update the form state with the selected files
                      field.onChange(e.target.files)
                    }}
                  />
                )}
              />
              {errors.pictures && <FormFeedback>{errors.pictures.message}</FormFeedback>}
            </Col>
          </Row>
        </>
      )}
      {product === 2 && (
        <>
          <hr className="my-3" />
          <h5>Boxspring / Frame / Ambiance E-Motion</h5>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="boxspringModel">Model</Label>
              <Controller
                name="boxspringModel"
                id="boxspringModel"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    onChange={(e) => {
                      if (e && e.value) {
                        setProductModelId(e.value)
                        setProductModel(e ? e.label : null)
                        setDisabledSize(false)
                        setValue("boxspringSize", null)
                      }
                    }}
                    defaultOptions={productModel}
                    loadOptions={productModel}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="6" className="mb-1">
              <Label for="boxspringSize">Size</Label>
              <Controller
                name="boxspringSize"
                id="boxspringSize"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    isDisabled={disabledSize}
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={productSize}
                    loadOptions={() => Promise.resolve(productSize)}
                  />
                )}
              />
            </Col>
            <Col md="6" className="mb-1">
              <Label for="boxspringComplaintReason">Reason for complaint</Label>
              <Controller
                name="boxspringComplaintReason"
                id="boxspringComplaintReason"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={[
                      { value: "material", label: "Material" },
                      { value: "cover", label: "Cover" }
                    ]}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="boxspringProblemDetail">
                Please describe the problem in more detail:
              </Label>
              <Controller
                id="boxspringProblemDetail"
                name="boxspringProblemDetail"
                control={control}
                render={({ field }) => (
                  <Input
                    type="textarea"
                    placeholder="Describe the problem"
                    invalid={errors.boxspringProblemDetail && true}
                    {...field}
                  />
                )}
              />
              {errors.boxspringProblemDetail && (
                <FormFeedback>{errors.boxspringProblemDetail.message}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="boxspringPictures">Pictures</Label>
              <Controller
                id="boxspringPictures"
                name="boxspringPictures"
                control={control}
                render={({ field }) => (
                  <Input
                    type="file"
                    placeholder="Upload pictures"
                    invalid={errors.pictures && true}
                    multiple
                    onChange={(e) => {
                      // Update the form state with the selected files
                      field.onChange(e.target.files)
                    }}
                  />
                )}
              />
              {errors.pictures && <FormFeedback>{errors.pictures.message}</FormFeedback>}
            </Col>
          </Row>
        </>
      )}
      {product === 3 && (
        <>
          <hr className="my-3" />
          <h5>Headboard</h5>
          <Row className="mb-1">
            <Col md="6" className="mb-1">
              <Label for="headboardModel">Model</Label>
              <Controller
                name="headboardModel"
                id="headboardModel"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    onChange={(e) => {
                      if (e && e.value) {
                        setDisabledSize(false)
                        setProductModelId(e.value)
                        setProductModel(e ? e.label : null)
                        setValue("headboardSize", null)
                      }
                    }}
                    defaultOptions={productModel}
                    loadOptions={productModel}
                  />
                )}
              />
            </Col>
            <Col md="6" className="mb-1">
              <Label for="headboardSize">Size</Label>
              <Controller
                name="headboardSize"
                id="headboardSize"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    isDisabled={disabledSize}
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={productSize}
                    loadOptions={() => Promise.resolve(productSize)}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="headboardComplaintReason">Reason for complaint</Label>
              <Controller
                name="headboardComplaintReason"
                id="headboardComplaintReason"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={[
                      { value: "material", label: "Material" },
                      { value: "cover", label: "Cover" },
                      { value: "assembly", label: "Assembly" }
                    ]}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="headboardProblemDetail">
                Please describe the problem in more detail:
              </Label>
              <Controller
                id="headboardProblemDetail"
                name="headboardProblemDetail"
                control={control}
                render={({ field }) => (
                  <Input
                    type="textarea"
                    placeholder="Describe the problem"
                    invalid={errors.headboardProblemDetail && true}
                    {...field}
                  />
                )}
              />
              {errors.headboardProblemDetail && (
                <FormFeedback>{errors.headboardProblemDetail.message}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="headboardPictures">Pictures</Label>
              <Controller
                id="headboardPictures"
                name="headboardPictures"
                control={control}
                render={({ field }) => (
                  <Input
                    type="file"
                    placeholder="Upload pictures"
                    invalid={errors.pictures && true}
                    multiple
                    onChange={(e) => {
                      // Update the form state with the selected files
                      field.onChange(e.target.files)
                    }}
                  />
                )}
              />
              {errors.pictures && <FormFeedback>{errors.pictures.message}</FormFeedback>}
            </Col>
          </Row>
        </>
      )}
      {product === 4 && (
        <>
          <hr className="my-3" />
          <h5>Duvet / Pillow / Bed linen / Accessories</h5>
          <Row className="mb-1">
            <Col md="6" className="mb-1">
              <Label for="duvetProduct">Product type</Label>
              <Controller
                name="duvetProduct"
                id="duvetProduct"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    onChange={(e) => {
                      if (e && e.value) setTypeProduct(e.value)
                      setValue("duvetModel", null)
                      setValue("duvetSize", null)
                      setDisabledModel(false)
                      setDisabledSize(true)
                      field.onChange(e)
                    }}
                    defaultOptions={[
                      { value: "Bathrobe", label: "Bathrobe" },
                      { value: "Duvet", label: "Duvet" },
                      { value: "DuvetCover", label: "Duvet cover" },
                      { value: "DuvetCoverOP1", label: "Duvet cover OP1" },
                      { value: "DuvetCoverOP2", label: "Duvet Cover OP2" },
                      { value: "FittedSheet", label: "Fitted sheet" },
                      { value: "FlatbedSheet", label: "Flat bed sheet" },
                      { value: "FlatTopSheet", label: "Flat top sheet" },
                      { value: "Fleece", label: "Fleece" },
                      { value: "Pillow", label: "Pillow" },
                      { value: "Pillowcase", label: "Pillow case" },
                      { value: "Sponge", label: "Sponge" }
                    ]}
                  />
                )}
              />
            </Col>
            <Col md="6" className="mb-1">
              <Label for="duvetModel">Model</Label>
              <Controller
                name="duvetModel"
                id="duvetModel"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    isDisabled={disabledModel}
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={productModel}
                    loadOptions={() => Promise.resolve(productModel)}
                    onChange={(e) => {
                      field.onChange(e) // Ensure the field value is updated
                      setProductModelId(e ? e.value : null)
                      setDisabledSize(false)
                    }}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="6" className="mb-1">
              <Label for="duvetSize">Size</Label>
              <Controller
                name="duvetSize"
                id="duvetSize"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isDisabled={disabledSize}
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={productSize}
                    loadOptions={() => Promise.resolve(productSize)}
                  />
                )}
              />
            </Col>
            <Col md="6" className="mb-1">
              <Label for="duvetComplaintReason">Reason for complaint</Label>
              <Controller
                name="duvetComplaintReason"
                id="duvetComplaintReason"
                control={control}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    isClearable
                    isSearchable
                    className="react-select"
                    classNamePrefix="select"
                    cacheOptions
                    defaultOptions={[
                      { value: "material", label: "Material" },
                      { value: "cover", label: "Cover" }
                    ]}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="duvetProblemDetail">Please describe the problem in more detail:</Label>
              <Controller
                id="duvetProblemDetail"
                name="duvetProblemDetail"
                control={control}
                render={({ field }) => (
                  <Input
                    type="textarea"
                    placeholder="Describe the problem"
                    invalid={errors.duvetProblemDetail && true}
                    {...field}
                  />
                )}
              />
              {errors.duvetProblemDetail && (
                <FormFeedback>{errors.duvetProblemDetail.message}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="12" className="mb-1">
              <Label for="duvetPictures">Pictures</Label>
              <Controller
                id="duvetPictures"
                name="duvetPictures"
                control={control}
                render={({ field }) => (
                  <Input
                    type="file"
                    placeholder="Upload pictures"
                    invalid={errors.pictures && true}
                    multiple
                    onChange={(e) => {
                      // Update the form state with the selected files
                      field.onChange(e.target.files)
                    }}
                  />
                )}
              />
              {errors.pictures && <FormFeedback>{errors.pictures.message}</FormFeedback>}
            </Col>
          </Row>
        </>
      )}
      <Row className="d-flex">
        <Col className="align-self-center text-end">
          {isSubmitting || isSubmitSuccessful ? (
            <Button color="light" disabled>
              {isSubmitting && <Spinner color="dark" size="sm" />}
              <span className="ms-50">{isSubmitting ? "Loading..." : "Submitted"}</span>
            </Button>
          ) : (
            <Button color="success" type="submit" disabled={disactivateButton}>
              Add {props.eventReason.label}
            </Button>
          )}
        </Col>
      </Row>
    </Form>
  )
}

export default ComplaintForm
